import Router from "vue-router";
import ChatBot from "./views/ChatBot.vue";
import UrlRedirector from "./views/UrlRedirector.vue";


// set available paths
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,

  routes: [
    {
      path: "/",
      name: "chatbot",
      component: ChatBot,
    },
    {
      path: '/redirect/:webId/:sessionId/*',
      name: "urlredirector",
      component: UrlRedirector,
    }
  ],
});